import { View, Text, StyleSheet, Pressable, Modal } from 'react-native';
import React, { useState } from 'react';
import WalletUserDetails from './WalletUserDetails';
import { IUser } from '../../../types/user';
import GenericButton from '../../../components/molecules/buttons/GenericButton';
import SendUserCredModal from '../../../modal/SendUserCredModal';

interface IWalletUserItemProps {
  user: IUser;
}

/**
 * WalletUserItem component
 *
 * @param {*} { user }
 * @return {*}
 */
const WalletUserItem: React.FC<IWalletUserItemProps> = ({ user }) => {
  const [visible, setVisible] = useState(false);
  const [sendUserCredModalOpen, setSendUserCredModalOpen] = useState(false);

  const onOpenDetails = () => {
    setVisible(true);
  };

  return (
    <>
      <Modal transparent visible={visible}>
        <WalletUserDetails user={user} setVisible={setVisible} />
      </Modal>
      <SendUserCredModal
        isVisible={sendUserCredModalOpen}
        onClose={() => setSendUserCredModalOpen(false)}
        user={user}
      />
      <Pressable onPress={() => onOpenDetails()}>
        <View style={styles.card}>
          <View style={styles.userInfo}>
            <View style={styles.avatarContainer}>
              <Text style={styles.avatarText}>
                {user.tenant_name?.charAt(0).toUpperCase() || 'U'}
              </Text>
            </View>
            <View style={styles.textContainer}>
              <Text style={styles.name}>{user.tenant_name}</Text>
              <Text style={styles.email}>{user.email}</Text>
              <Text style={styles.status}>Active Wallet</Text>
            </View>
          </View>
          <GenericButton
            title={'Issue Credential'}
            onPress={() => setSendUserCredModalOpen(true)}
            isPrimary={true}
            buttonStyle={styles.button}
            textStyle={styles.buttonText}
          />
        </View>
      </Pressable>
    </>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    marginHorizontal: 16,
    marginVertical: 8,
    padding: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    borderLeftWidth: 4,
    borderLeftColor: '#28a745'
  },
  userInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  avatarContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#28a745',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12
  },
  avatarText: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: '600'
  },
  textContainer: {
    flex: 1
  },
  name: {
    fontSize: 16,
    fontWeight: '600',
    color: '#212529',
    marginBottom: 2
  },
  email: {
    fontSize: 14,
    fontWeight: '400',
    color: '#6c757d',
    marginBottom: 2
  },
  status: {
    fontSize: 12,
    fontWeight: '500',
    color: '#28a745'
  },
  button: {
    width: 140,
    height: 36,
    borderRadius: 6
  },
  buttonText: {
    fontSize: 13,
    fontWeight: '600'
  }
});

export default WalletUserItem;
